import styled from 'styled-components';

const RedText = styled.span`
  color: #e84118;
  margin-left: 10px;
`;

export default RedText;
